export const imagesDev = {
  "pr12-fiche-eye": {
    "id": "pr12-fiche-eye",
    "cover": "https://cv-api-omega.vercel.app/dev/fiche-eye/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/fiche-eye/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/1.webp",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/1.jpg",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/2.webp",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/2.jpg",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/3.webp",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/3.jpg",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/4.webp",
      "https://cv-api-omega.vercel.app/dev/fiche-eye/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/fiche-eye/4.jpg"
    ]
  },
  "pr11-moteur-recherche": {
    "id": "pr11-moteur-recherche",
    "cover": "https://cv-api-omega.vercel.app/dev/moteur_recherche/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/1.webp",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/1.jpg",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/2.webp",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/2.jpg",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/3.webp",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/3.jpg",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/4.webp",
      "https://cv-api-omega.vercel.app/dev/moteur_recherche/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/moteur_recherche/4.jpg"
    ]
  },
  "pr10-social-media": {
    "id": "pr10-social-media",
    "cover": "https://cv-api-omega.vercel.app/dev/social-media/2.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/social-media/0.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/0.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/0.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/0.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/00.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/00.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/00.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/00.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/1.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/1.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/2.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/2.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/3.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/3.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/4.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/4.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/5.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/5.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/5.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/6.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/6.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/6.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/7.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/7.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/7.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/7.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/8.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/8.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/8.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/8.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/9.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/9.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/9.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/9.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/10.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/10.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/10.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/10.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/11.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/11.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/11.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/11.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/12.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/12.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/12.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/12.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/13.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/13.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/13.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/13.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/14.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/14.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/14.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/14.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/15.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/15.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/15.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/15.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/16.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/16.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/16.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/16.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/17.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/17.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/17.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/17.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/18.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/18.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/18.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/18.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/19.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/19.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/19.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/19.jpg",
      "https://cv-api-omega.vercel.app/dev/social-media/20.webp",
      "https://boogysh.github.io/cv-api/images/dev/social-media/20.webp",
      "https://cv-api-omega.vercel.app/dev/social-media/20.jpg",
      "https://boogysh.github.io/cv-api/images/dev/social-media/20.jpg"
    ]
  },
  "pr9-netflix-youtube": {
    "id": "pr9-netflix-youtube",
    "cover": "https://cv-api-omega.vercel.app/dev/netflix/1.jpg",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/netflix/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/1.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/1.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/2.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/2.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/3.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/3.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/4.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/4.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/5.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/5.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/5.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/6.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/6.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/6.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/7.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/7.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/7.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/7.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/8.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/8.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/8.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/8.jpg",
      "https://cv-api-omega.vercel.app/dev/netflix/9.webp",
      "https://boogysh.github.io/cv-api/images/dev/netflix/9.webp",
      "https://cv-api-omega.vercel.app/dev/netflix/9.jpg",
      "https://boogysh.github.io/cv-api/images/dev/netflix/9.jpg"
    ]
  },
  "pr8-castle": {
    "id": "pr8-castle",
    "cover": "https://cv-api-omega.vercel.app/dev/kasa/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/castle/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/1.webp",
      "https://cv-api-omega.vercel.app/dev/castle/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/1.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/2.webp",
      "https://cv-api-omega.vercel.app/dev/castle/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/2.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/3.webp",
      "https://cv-api-omega.vercel.app/dev/castle/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/3.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/4.webp",
      "https://cv-api-omega.vercel.app/dev/castle/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/4.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/5.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/5.webp",
      "https://cv-api-omega.vercel.app/dev/castle/5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/5.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/6.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/6.webp",
      "https://cv-api-omega.vercel.app/dev/castle/6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/6.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/7.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/7.webp",
      "https://cv-api-omega.vercel.app/dev/castle/7.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/7.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/8.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/8.webp",
      "https://cv-api-omega.vercel.app/dev/castle/8.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/8.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/9.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/9.webp",
      "https://cv-api-omega.vercel.app/dev/castle/9.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/9.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/10.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/10.webp",
      "https://cv-api-omega.vercel.app/dev/castle/10.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/10.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/11.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/11.webp",
      "https://cv-api-omega.vercel.app/dev/castle/11.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/11.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/12.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/12.webp",
      "https://cv-api-omega.vercel.app/dev/castle/12.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/12.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/13.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/13.webp",
      "https://cv-api-omega.vercel.app/dev/castle/13.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/13.jpg",
      "https://cv-api-omega.vercel.app/dev/castle/14.webp",
      "https://boogysh.github.io/cv-api/images/dev/castle/14.webp",
      "https://cv-api-omega.vercel.app/dev/castle/14.jpg",
      "https://boogysh.github.io/cv-api/images/dev/castle/14.jpg"
    ]
  },
  "pr7-kasa": {
    "id": "pr7-kasa",
    "cover": "https://cv-api-omega.vercel.app/dev/kasa/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/kasa/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/1.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/1.jpg",
      "https://cv-api-omega.vercel.app/dev/kasa/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/2.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/2.jpg",
      "https://cv-api-omega.vercel.app/dev/kasa/3.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/3.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/3.jpg",
      "https://cv-api-omega.vercel.app/dev/kasa/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/4.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/4.jpg",
      "https://cv-api-omega.vercel.app/dev/kasa/5.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/5.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/5.jpg",
      "https://cv-api-omega.vercel.app/dev/kasa/404.webp",
      "https://boogysh.github.io/cv-api/images/dev/kasa/404.webp",
      "https://cv-api-omega.vercel.app/dev/kasa/404.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kasa/404.jpg"
    ]
  },
  "pr6-api-piquante": {
    "id": "pr6-api-piquante",
    "cover": "https://cv-api-omega.vercel.app/dev/piquante/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/piquante/1.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/1.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/1.jpg",
      "https://cv-api-omega.vercel.app/dev/piquante/2.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/2.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/2.jpg",
      "https://cv-api-omega.vercel.app/dev/piquante/4.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/4.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/4.jpg",
      "https://cv-api-omega.vercel.app/dev/piquante/5.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/5.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/5.jpg",
      "https://cv-api-omega.vercel.app/dev/piquante/6.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/6.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/6.jpg",
      "https://cv-api-omega.vercel.app/dev/piquante/7.webp",
      "https://boogysh.github.io/cv-api/images/dev/piquante/7.webp",
      "https://cv-api-omega.vercel.app/dev/piquante/7.jpg",
      "https://boogysh.github.io/cv-api/images/dev/piquante/7.jpg"
    ]
  },
  "pr5-eCommerce": {
    "id": "pr5-eCommerce",
    "cover": "https://cv-api-omega.vercel.app/dev/kanap/1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-1.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-1.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-1.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-2.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-2.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-2.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-3.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-3.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-3.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-4.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-4.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-4.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-5.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-5.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-5.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-6.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-6.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-6.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-7.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-7.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-7.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-7.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-8.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-8.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-8.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-8.jpg",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-9.webp",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-9.webp",
      "https://cv-api-omega.vercel.app/dev/kanap/kanap-9.jpg",
      "https://boogysh.github.io/cv-api/images/dev/kanap/kanap-9.jpg"
    ]
  },
  "pr4-SEO": {
    "id": "pr4-SEO",
    "cover": "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-1.webp",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-1.webp",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-1.jpg",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-2.webp",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-2.webp",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-2.jpg",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-3.webp",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-3.webp",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-3.jpg",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-4.webp",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-4.webp",
      "https://cv-api-omega.vercel.app/dev/lapanthere.fr/lapanthere-4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/lapanthere.fr/lapanthere-4.jpg"
    ]
  },
  "pr3-ohmyfood": {
    "id": "pr3-ohmyfood",
    "cover": "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-1.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-1.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-1.jpg",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-2.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-2.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-2.jpg",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-3.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-3.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-3.jpg",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-4.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-4.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-4.jpg",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-5.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-5.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-5.jpg",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-6.webp",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-6.webp",
      "https://cv-api-omega.vercel.app/dev/ohmyfood/ohmyfood-6.jpg",
      "https://boogysh.github.io/cv-api/images/dev/ohmyfood/ohmyfood-6.jpg"
    ]
  },
  "pr2-booki": {
    "id": "pr2-booki",
    "cover": "https://cv-api-omega.vercel.app/dev/booki/booki-1.png",
    "pictures": [
      "https://cv-api-omega.vercel.app/dev/booki/booki-1.webp",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-1.webp",
      "https://cv-api-omega.vercel.app/dev/booki/booki-1.jpg",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-1.jpg",
      "https://cv-api-omega.vercel.app/dev/booki/booki-2.webp",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-2.webp",
      "https://cv-api-omega.vercel.app/dev/booki/booki-2.jpg",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-2.jpg",
      "https://cv-api-omega.vercel.app/dev/booki/booki-3.webp",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-3.webp",
      "https://cv-api-omega.vercel.app/dev/booki/booki-3.jpg",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-3.jpg",
      "https://cv-api-omega.vercel.app/dev/booki/booki-4.webp",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-4.webp",
      "https://cv-api-omega.vercel.app/dev/booki/booki-4.jpg",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-4.jpg",
      "https://cv-api-omega.vercel.app/dev/booki/booki-5.webp",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-5.webp",
      "https://cv-api-omega.vercel.app/dev/booki/booki-5.jpg",
      "https://boogysh.github.io/cv-api/images/dev/booki/booki-5.jpg"
    ]
  }
};
